import SecondaryDomains from './secondary-domains';

export default function SecondaryDomainsPage() {
  return <SecondaryDomains />;
}
